import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import '../styles/global.css';
import '../styles/contact.css';
import { Helmet } from 'react-helmet';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: '',
  });
  
  const [formTouched, setFormTouched] = useState({
    name: false,
    email: false,
    message: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact Us';
    // Initialize AdSense
    try {
      if (window.adsbygoogle && process.env.NODE_ENV !== 'development') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setFormTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
    }
    
    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Touch all fields to show validation
    setFormTouched({
      name: true,
      email: true,
      message: true,
    });
  
    const errors = validateForm();
  
    if (Object.keys(errors).length === 0) {
      try {
        // Send form data to Formspree
        const response = await fetch('https://formspree.io/f/xeogoroj', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
  
        if (response.ok) {
          setFormStatus({
            submitted: true,
            error: false,
            message: 'Thanks for reaching out! We\'ll get back to you as soon as possible.',
          });
  
          // Clear form
          setFormData({
            name: '',
            email: '',
            subject: '',
            message: '',
          });
  
          // Reset touched state
          setFormTouched({
            name: false,
            email: false,
            message: false,
          });
        } else {
          throw new Error('Form submission failed');
        }
      } catch (error) {
        setFormStatus({
          submitted: true,
          error: true,
          message: 'Something went wrong. Please try again later.',
        });
      }
    } else {
      setFormStatus({
        submitted: true,
        error: true,
        message: 'Please fill out all required fields correctly.',
      });
    }
  };

  const errors = validateForm();

  return (
    <div className="contact-container">
      <Header />
      <Helmet>
      <title>Contact us</title>
      <meta name="description" content="Our Contact info to send us any feedback or questions." />
    </Helmet>
      <section className="contact-hero">
        <div className="contact-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Get In Touch
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lead-text"
          >
            Have questions or feedback? We'd love to hear from you.
          </motion.p>
        </div>
      </section>
      
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            <motion.div 
              className="contact-info"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="info-card">
                <h2>Contact Information</h2>
                <p>Feel free to reach out using the form or contact us directly using the information below.</p>
                
                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="info-content">
                    <h3>Email Us</h3>
                    <p><a href="mailto:support@nivexa.net">support@nivexa.net</a></p>
                  </div>
                </div>
                
                <div className="info-item">
                  {/* <div className="info-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div> */}
                  {/* <div className="info-content">
                    <h3>Call Us</h3>
                    <p><a href="tel:+15551234567">(555) 123-4567</a></p>
                    <p className="text-small">Monday - Friday: 9am - 5pm PST</p>
                  </div> */}
                </div>
                
                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="info-content">
                    <h3>Visit Us</h3>
                    <p>123 Wellness Ave, Suite 200<br/>San Francisco, CA 94110</p>
                  </div>
                </div>
                
                <div className="social-connect">
                  <h3>Connect With Us</h3>
                  <div className="social-icons">
                    <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                    <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                    <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                    <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                  </div>
                </div>
              </div>
              
              {/* Side Ad Placement */}
              <div className="ad-container contact-side-ad"  style={{width: "100%", minWidth: "300px"}}>
                {/* <div className="ad-label">Advertisement</div> */}
                <ins className="adsbygoogle"
                    style={{ display: 'block' }}
                    data-ad-client="ca-pub-2067522743161930"
                    data-ad-slot="1234567892"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
              </div>
            </motion.div>
            
            <motion.div 
              className="contact-form-container"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="form-card">
                <h2>Send Us a Message</h2>
                <p>Fill out the form below and we'll get back to you as soon as possible.</p>
                
                {formStatus.submitted && (
                  <div className={`form-message ${formStatus.error ? 'error' : 'success'}`}>
                    <p>{formStatus.message}</p>
                  </div>
                )}
                
                <form action="https://formspree.io/f/xeogoroj"method="POST" onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Your Name <span className="required">*</span></label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={formTouched.name && errors.name ? 'error' : ''}
                    />
                    {formTouched.name && errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Your Email <span className="required">*</span></label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={formTouched.email && errors.email ? 'error' : ''}
                    />
                    {formTouched.email && errors.email && (
                      <span className="error-message">{errors.email}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Your Message <span className="required">*</span></label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={formTouched.message && errors.message ? 'error' : ''}
                    ></textarea>
                    {formTouched.message && errors.message && (
                      <span className="error-message">{errors.message}</span>
                    )}
                  </div>
                  
                  <div className="form-submit">
                    <button type="submit" className="submit-button">
                      <span>Send Message</span>
                      <i className="fas fa-paper-plane"></i>
                    </button>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      
      <section className="contact-map">
        <div className="container">
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50470.25247860543!2d-122.4725208!3d37.7577627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1635187472626!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </section>
      
      <section className="contact-faq">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          
          <div className="faq-grid">
            <motion.div 
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <h3>Is my assessment data private?</h3>
              <p>Yes, all assessment responses are confidential. We do not store personally identifiable information with your responses, and your data is never shared with third parties.</p>
            </motion.div>
            
            <motion.div 
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h3>Can I retake the assessment?</h3>
              <p>Absolutely! You can retake the assessment as many times as you'd like. This can be helpful if your relationship dynamics have changed over time.</p>
            </motion.div>
            
            <motion.div 
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h3>Do you offer relationship counseling?</h3>
              <p>We don't provide direct counseling services, but we can refer you to qualified therapists and counselors in your area who specialize in relationship issues.</p>
            </motion.div>
            
            <motion.div 
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <h3>How scientific is the assessment?</h3>
              <p>Our assessment is based on established relationship research and psychological principles. However, it's designed as a helpful tool, not a clinical diagnosis.</p>
            </motion.div>
          </div>
          
          <div className="faq-more">
            <a href="/faq" className="view-more-link">
              <span style={{color:"#492a9a"}}>View More FAQs</span>
              <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </section>
      
      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3 style={{color:"#FFF"}}>Relationship Wellness</h3>
              <p style={{color:"#FFF"}}>Evidence-based insights for healthier relationships.</p>
              <div className="social-icons">
                <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
            <div className="footer-links">
              <h4 style={{color:"#FFF"}}>Quick Links</h4>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/blog">Blog</a></li>
                <li><a href="/resources">Resources</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-contact">
              <h4 style={{color:"#FFF"}}>Contact Us</h4>
              <p><i className="fas fa-envelope"></i> support@nivexa.net</p>
              {/* <p><i className="fas fa-phone"></i> (555) 123-4567</p> */}
              <p><i className="fas fa-map-marker-alt"></i> 123 Wellness Ave, Suite 200<br/>San Francisco, CA 94110</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="copyright">© {new Date().getFullYear()} Relationship Wellness. All rights reserved.</p>
            <div className="legal-links">
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Use</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
